import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { SettingsService } from 'src/app/settings.service';
import { ThemingService } from 'src/app/theming.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { LambdaService } from 'src/app/lambda.service';
declare var $: any;

@Component({
  selector: 'app-edit-sub-subcategory',
  templateUrl: './edit-sub-subcategory.component.html',
  styleUrls: ['./edit-sub-subcategory.component.scss']
})
export class EditSubSubcategoryComponent implements OnInit {
  @Output() subSubCategoryUpdated = new EventEmitter<void>();
  subSubCategory: any;
  subCategories: any =[];
  loading: boolean = false;
  imageUrl: SafeUrl | null = null;
  timekitResources: any = [];
  category: any = {};
  categories: any =[];

  @Input() subSubCategoryId!: string;
  @Input() categoryId!: string;
  @Input() id!: string;  
  
  constructor(
    private settingsService: SettingsService,
    private apiService: ApiService,
    private themingService: ThemingService,
    private sanitizer: DomSanitizer,
    private lambdaService: LambdaService,
  ) { }

  ngOnInit(): void {
    this.getEditingSubSubCategory();
    this.getSubSubCategoryById();
    this.getSubCategoryByCategoryId(parseInt(this.categoryId));
    this.getCategories();
  }

  getSubSubCategoryById() {
    this.loading = true;
    this.lambdaService.getSubSubCategoryById(this.id, this.themingService.shopId)
      .then((data: any) => {
        this.subSubCategory = data.subSubCategory;
        this.category = {
          timekitResourceId: this.subSubCategory.timekitResourceId
        };
        this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.subSubCategory.subSubCategoryImageUrl);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  
  getSubCategoryByCategoryId(categoryId: number) {
    this.lambdaService.getSubCategoryByCategoryId( categoryId,this.themingService.shopId, )
      .then((data: any) => {
        this.subCategories = data.subCategories;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
  
      });
  }

  async getCategories(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getCategories(this.themingService.shopId);
      const categoryRows = Array.isArray(response[0]) ? response[0] : [];
      this.categories = categoryRows;
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  }

  onSwitchChange(event: any) {
    this.subSubCategory.isForVerifiedClient = event.checked ? 1 : 0;
  }

  getEditingSubSubCategory(){
    this.subSubCategoryId = this.settingsService.getEditingSubSubCategory();
  }

  setListingSubSubCategories(){
    this.settingsService.setListingSubSubCategories();
  }


  triggerFileInput() {
    const fileInput = document.getElementById('optionImage') as HTMLInputElement;
    fileInput.click();
  }

  private resizeImage(image: HTMLImageElement, maxWidth: number, maxHeight: number): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    let width = image.width;
    let height = image.height;

    if (width > height) {
      if (width > maxWidth) {
        height *= maxWidth / width;
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width *= maxHeight / height;
        height = maxHeight;
      }
    }

    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');
    context?.drawImage(image, 0, 0, width, height);

    return canvas;
  }

  private convertCanvasToFile(canvas: HTMLCanvasElement, fileName: string): File {
    const dataURL = canvas.toDataURL('image/jpeg');
    const base64Data = dataURL.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: 'image/jpeg' });
    return new File([blob], fileName);
  }

  async onImageChange(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = async (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(image.src); // Actualizar previsualización

        image.onload = async () => {
          const resizedImage = this.resizeImage(image, 1400, 250);
          const resizedFile = this.convertCanvasToFile(resizedImage, file.name);

          try {
            const imageData = await this.uploadImage(resizedFile);
            this.subSubCategory.subSubCategoryImageUrl = imageData.imageURL; // Actualizar URL de la imagen en el objeto categoría
          } catch (error) {
            console.error('Error uploading image:', error);
          }
        };
      };

      reader.readAsDataURL(file);
    }
  }

  removeImage() {
    this.imageUrl = null;
    this.subSubCategory.subSubCategoryImageUrl = ''; 
    const fileInput = document.getElementById('optionImage') as HTMLInputElement;
    fileInput.value = ''; 
  }

  uploadImage(image: File): Promise<any> {
    return this.blobFile(image)
      .then((res: any) => {
        const timestamp = Date.now();
        const ext = image.name.split('.').pop();
        const key = `${this.themingService.shopId}/${environment.stage}/images/subsubcategory/banner${timestamp}.${ext}`;
        return this.lambdaService.uploadFile(key, res.blob, { position: 1, type: 'original' })
          .then((data: any) => {
            return {
              imageURL: data.imageURL,
              blob: res.blob,
            };
          });
      });
  }

  blobFile = async ($event: any): Promise<any> => {
    try {
      const unSafeImg = window.URL.createObjectURL($event);
      const img = this.sanitizer.bypassSecurityTrustUrl(unSafeImg);
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve({
            blob: $event,
            img,
            base: reader.result
          });
        };
        reader.onerror = (error) => {
          reject({
            blob: $event,
            img,
            base: null
          });
        };
        reader.readAsDataURL($event);
      });
    } catch (e) {
      return Promise.reject(null);
    }
  };
  
  changeSubSubCategoryName(event: Event){
    const element = event.target as HTMLInputElement;
    this.subSubCategory.subSubCategoryName = element.value;
  }

  changeSubSubCategoryParentId(event: Event){
    const element = event.target as HTMLSelectElement;
    this.subSubCategory.subCategoryId = parseInt(element.value);
  }

  validateFormData() {
    this.loading = true; // Activar el spinner de carga al inicio
    this.lambdaService.updateSubSubCategory(
        parseInt(this.id),
        this.themingService.shopId,
        this.subSubCategory.subSubCategoryName,
        this.subSubCategory.subSubCategoryPosition,
        this.subSubCategory.menuSubSubCategory,
        this.subSubCategory.homeSubSubCategory,
        this.subSubCategory.subCategoryId,
        this.subSubCategory.subSubCategoryDesignType,
        this.subSubCategory.subSubCategoryImageUrl,
        this.subSubCategory.isForVerifiedClient,
    )
    .then((data: any) => {
        if (data.status === 200) {
          setTimeout(() => {
            this.subSubCategoryUpdated.emit();
          }, 2000); 
            $('#successSubSubCategoryModal').modal('show');
        } else {
            $('#errorSubSubCategoryModal').modal('show');
        }
    })
    .catch((error) => {
        console.error(error);
    })
    .finally(() => {
        this.loading = false; 
    });
  }

  closeModal(){
    $('#successSubSubCategoryModal').modal('hide');
    $('#errorSubSubCategoryModal').modal('hide');
  }
  preventNegativeNumbers(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '+') {
      event.preventDefault(); 
    }
  }
}
